export default __webpack_public_path__ + "static/media/Decentralized.3106c7e2.png";